import * as React from 'react';
import {Draggable} from 'react-beautiful-dnd';

import {DraggableRow} from 'shells/draggable-row/draggable-row';
import {DraggableRowOnHover} from 'shells/draggable-row/draggable-row-on-hover';

import type {ListItem} from './draggable-list';

type Props = {
    item: ListItem;
    index: number;
    disabled?: boolean;
    showDraggableRowOnlyOnHover?: boolean;
    showOverflow?: boolean;
    showHandleWhenDisabled?: boolean;
    draggedItemId: string | null | undefined;
    setDraggedItemId: (itemId?: string | null | undefined) => void;
    hoveredItemId: string | null | undefined;
    setHoveredItemId: (itemId?: string | null | undefined) => void;
    getDraggingStyle: (draggableStyle: any) => any;
};

export function DraggableListItem(props: Props) {
    return (
        <Draggable
            key={props.item.id}
            index={props.index}
            draggableId={props.item.id}
            isDragDisabled={props.disabled || props.item.isDisabled}
        >
            {(draggableProvided, draggableSnapshot) => {
                const style = props.getDraggingStyle(draggableProvided.draggableProps.style);

                return (
                    <div>
                        <div
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            style={style}
                        >
                            {props.showDraggableRowOnlyOnHover ? (
                                <DraggableRowOnHover
                                    dragHandleProps={{
                                        ...draggableProvided.dragHandleProps,
                                    }}
                                    disableHover={
                                        Boolean(props.draggedItemId) &&
                                        props.draggedItemId !==
                                            draggableProvided.draggableProps[
                                                'data-rbd-draggable-id'
                                            ]
                                    }
                                    isActive={props.item.isActive || draggableSnapshot.isDragging}
                                    onHoverBegin={() => {
                                        props.setHoveredItemId(props.item.id);
                                    }}
                                    onHoverEnd={() => {
                                        // We know that this doesn't always get
                                        // called, which is why we're tracking the
                                        // hovered state here instead of in the
                                        // draggable item
                                        props.setHoveredItemId(null);
                                    }}
                                    isHovered={props.item.id === props.hoveredItemId}
                                >
                                    {props.item.component}
                                </DraggableRowOnHover>
                            ) : (
                                <DraggableRow
                                    dragHandleProps={draggableProvided.dragHandleProps}
                                    disabled={props.disabled || props.item.isDisabled}
                                    showOverflow={props.showOverflow}
                                    showHandleWhenDisabled={props.showHandleWhenDisabled}
                                >
                                    {props.item.component}
                                </DraggableRow>
                            )}
                        </div>
                        {/* @ts-expect-error */}
                        {draggableProvided.placeholder}
                    </div>
                );
            }}
        </Draggable>
    );
}
